import React, { forwardRef } from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import BadgeParagraph from "./BadgeParagraph";

import styles from "./Badge.scss";

export const Badge = forwardRef(
  (
    { children, variants, colors, customClass, innerCustomClass, ...restProps },
    ref
  ) => {
    let isRounded = false;
    let isLabel = false;

    if (variants === styles.roundPrimary) {
      isRounded = true;
    }

    if (variants === styles.label) {
      isLabel = true;
    }

    const wrapperClasses = cx(styles.wrapper, customClass);
    const badgeClasses = cx(styles.badge, innerCustomClass, variants, colors);

    return (
      <div className={wrapperClasses} ref={ref}>
        <div className={badgeClasses} {...restProps}>
          <div className={isLabel ? styles.labelWrapper : styles.normalWrapper}>
            <p className={isRounded ? styles.rotateText : styles.normalText}>
              {children}
            </p>
          </div>
        </div>
      </div>
    );
  }
);

Badge.propTypes = {
  customClass: PropTypes.string,
  innerCustomClass: PropTypes.string,
  colors: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  variants: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

Badge.defaultProps = {
  customClass: undefined,
  innerCustomClass: undefined,
  colors: styles.lightBlue,
  variants: styles.roundPrimary,
};

Badge.Variant = {
  roundPrimary: styles.roundPrimary,
  flag: styles.flag,
  rectangle: styles.rectangle,
  label: styles.label,
};

Badge.Color = {
  magenta: styles.magenta,
  black: styles.black,
  white: styles.white,
  lightBlue: styles.lightBlue,
};

Badge.Paragraph = BadgeParagraph;

Badge.displayName = "Badge";

export default Badge;
